
(function ($) {
    //Smoothly scrolls to element on Tell Me More page
    $(".question-items").on("click", "a", function (e) {
        e.preventDefault();

        let headerHeight = $("header").innerHeight(),
            target = e.target.getAttribute('href'),
            targetOffset = $(target).offset();

        if (targetOffset) {
            $("html, body").animate({
                scrollTop: targetOffset.top - (headerHeight)
            }, 1000);
        } else {
            return;
        }
    });

})(jQuery);



// WEBPACK FOOTER //
// ./src/js/custom/scroll-to.es6